import { Table } from "@mantine/core";

import { PROCEDURE_COLUMNS } from "../constants/fee-table";

export default function ProcedureTableHeader() {
  return (
    <Table.Thead bg="gray.0" style={{ borderTop: "1px solid var(--mantine-color-cream-4)" }}>
      <Table.Tr>
        {PROCEDURE_COLUMNS.map((column) => (
          <Table.Th key={column.key} ta={column.align} colSpan={column.colSpan}>
            {column.label}
          </Table.Th>
        ))}
      </Table.Tr>
    </Table.Thead>
  );
}
